// extracted by css-extract-rspack-plugin
export default {"row":"row-w6aknq","sm":"sm-TeG6Kz","label":"label-N86Jah","value":"value-zTBgLj"};